import script from "./FileDropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDropzone.vue?vue&type=script&setup=true&lang=js"

import "./FileDropzone.vue?vue&type=style&index=0&id=14fc5621&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fc5621"]])

export default __exports__